import React from "react";
import "./MilestonesCard.css";

/** Loading placeholder for {@link MilestonesCard} — mirrors its layout. */
export const MilestonesSkeleton: React.FC = () => (
  <div className="milestones-card">
    <div className="milestones-head">
      <div>
        <div className="lyra-skeleton milestones-skeleton-title" />
        <div className="lyra-skeleton milestones-skeleton-subtitle" />
      </div>
    </div>
    <div className="lyra-skeleton milestones-skeleton-bar" />
    <div className="milestones-timeline">
      {[0, 1, 2, 3, 4, 5].map((i) => (
        <div className="milestone-node" key={i}>
          <div className="lyra-skeleton milestone-skeleton-dot" />
          <div className="lyra-skeleton milestone-skeleton-label" />
        </div>
      ))}
    </div>
  </div>
);
